import React, { Component } from "react";
import {
  Drawer,
  Form,
  Button,
  Col,
  Row,
  Input,
  Select,
  DatePicker,
  notification,
  Space,
  Spin
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import "../styles/general.css";

import { MakeRequestAsync } from "../functions/axios";
import { POST } from "../constants/request-type";
import { service_api } from "../constants/url";
import {} from "../constants/routes";
import { openNotificationWithIcon } from "../functions/notification";
import { raw_menu } from "../constants/raw-list";

const token = sessionStorage.getItem("auth_token");

const { Option } = Select;

class Withdrawal_request extends Component {
  state = {
    visible: false,
    title: "",
    description: "",
    locked: false,
    load: false
  };

  componentDidMount() {}
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ load: true });

    const { amount, bank_name, account_name, account_number, branch_code } =
      this.state;

    const data = {
      amount: amount,
      account_detail: {
        bank_name: bank_name,
        account_name: account_name.toLowerCase(),
        account_number: account_number.toLowerCase(),
        branch_code: branch_code.toLowerCase()
      },
      entity_id: this.props.row?.admin?._id,
      type: "glocery-partner"
    };

    console.log(token);

    const request_details = {
      type: POST,
      url: service_api,
      route: "withdrawal" + "/" + "create-withdrawal-glocery",
      data: data,
      token: token
    };

    // if (data.amount.length === 0 || data.description.length === 0) {
    //   this.setState({ load: false });
    //   return openNotificationWithIcon(
    //     "error",
    //     "Vous devez remplir tous les champs"
    //   );
    // }

    const response = await MakeRequestAsync(request_details).catch((err) => {
      console.log(err);
      this.setState({ load: false });
      return openNotificationWithIcon("error", err?.response?.message);
    });

    // return setTimeout(() => window.location.reload(), 0);
  };

  showDrawer = () => {
    this.setState({
      visible: true
    });
  };

  onClose = () => {
    this.setState({
      visible: false
    });
  };

  render() {
    const {
      amount,
      bank_name,
      account_name,
      account_number,
      branch_code,
      locked,
      load
    } = this.state;
    return (
      <>
        <Button type="primary" onClick={this.showDrawer}>
          <PlusOutlined />
          Withdrawal Request
        </Button>
        <Drawer
          title="Withdrawal request"
          width={720}
          onClose={this.onClose}
          visible={this.state.visible}
          bodyStyle={{ paddingBottom: 80 }}
          footer={
            <div
              style={{
                textAlign: "right"
              }}
            >
              {load ? (
                <Space size="middle">
                  <Spin size="large" />
                </Space>
              ) : (
                <div>
                  <Button onClick={this.onClose} style={{ marginRight: 8 }}>
                    Annuler
                  </Button>
                  <Button
                    onClick={(e) => {
                      this.handleSubmit(e);
                    }}
                    type="primary"
                  >
                    Soumettre
                  </Button>
                </div>
              )}
            </div>
          }
        >
          <Form layout="vertical" hideRequiredMark>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="amount"
                  label="Amount"
                  rules={[
                    {
                      required: true,
                      title: "Amount"
                    }
                  ]}
                >
                  <Input
                    name="amount"
                    placeholder="Amount"
                    onChange={this.handleChange}
                    value={amount}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="bank_name"
                  label="Bank name"
                  rules={[
                    {
                      required: true,
                      description: "bank name"
                    }
                  ]}
                >
                  <Input
                    name="bank_name"
                    placeholder="Bank name"
                    onChange={this.handleChange}
                    value={bank_name}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="account_number"
                  label="Account number"
                  rules={[
                    {
                      required: true,
                      description: "account number"
                    }
                  ]}
                >
                  <Input
                    name="account_number"
                    placeholder="Account number"
                    onChange={this.handleChange}
                    value={account_number}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="branch_code"
                  label="Branch code"
                  rules={[
                    {
                      required: true,
                      description: "branch code"
                    }
                  ]}
                >
                  <Input
                    name="branch_code"
                    placeholder="Branch code"
                    onChange={this.handleChange}
                    value={branch_code}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="account_name"
                  label="Account name"
                  rules={[
                    {
                      required: true,
                      description: "account name"
                    }
                  ]}
                >
                  <Input
                    name="account_name"
                    placeholder="Account name"
                    onChange={this.handleChange}
                    value={account_name}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Drawer>
      </>
    );
  }
}

export default Withdrawal_request;
